export default __webpack_public_path__ + "static/media/splash_background.7460a986.jpg";